import { Dayjs } from 'dayjs';

export * from './modal';

export const concatString = (strings: string[]) => strings.reduce(
  (accumulator, currentValue, index) => {
    if (!currentValue) {
      return accumulator;
    }
    if (index === 0) {
      return currentValue;
    }
    return `${accumulator} ${currentValue}`;
  },
  '',
);

export const compareDates = (a: Dayjs, b: Dayjs) => (a.isBefore(b) ? -1 : 1);

// удаляем все символы кроме букавок
const prepareString = (str: string): string => str.replace(/[^а-яА-Яa-zA-Z]/g, '');

export const compareString = (a: number | string, b: number | string) => {
  if (a == null) {
    return 1;
  }
  if (b == null) {
    return -1;
  }

  if (typeof a === 'number' && typeof b === 'number') {
    return a - b;
  }

  const x = typeof a === 'string' ? prepareString(a.toLowerCase()) : prepareString(a.toString());
  const y = typeof b === 'string' ? prepareString(b.toLowerCase()) : prepareString(b.toString());

  return x.localeCompare(y);
};

export const compareStringBySortMap = (a: string, b: string, sortingMap: Record<string, number>) => sortingMap[a] - sortingMap[b];

export const truncateString = (str: string, maxLength: number) => {
  if (str?.length > maxLength) {
    return `${str.slice(0, maxLength)}...`;
  }
  return str;
};
